// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-n_fM","advertDetailHeaderLocation__value":"c-n_fN"};